<template>
    <div @click.prevent.stop
        :class="[singleVideoMode ? '' : 'flex flex-row justify-between items-center w-full max-w-2xl py-2 pl-4 pr-2 bg-gray-900 text-white rounded-xl shadow-lg text-sm pointer-events-auto gap-y-2 relative']">
        <div v-if="!singleVideoMode"
            class="rounded-full hover:bg-white/10 size-6 flex items-center justify-center cursor-pointer mr-2 flex-shrink-0"
            @click="unselectAllVideos()">
            <XMarkIcon class="size-4" />
        </div>
        <div v-if="!singleVideoMode" class="flex items-center justify-start flex-shrink-0 font-bold">
            <span>{{ selectedVideos.length }}</span>
            <span class="ml-1" v-html="selectedVideos.length > 1 ? 'videos' : 'video'"></span>
        </div>
        <div class="flex justify-end items-center ml-4 relative flex-grow">
            <div class="flex w-full justify-end items-center gap-x-4">

                <Menu v-if="_way != 'search' && _way != 'unified_personals'" as="div"
                    class="ml-2 relative z-10 flex items-center justify-center " v-slot="{ close, open }">
                    <span v-if="open && !singleVideoMode" class="text-gray-200 text-xs mr-5">Move to folder…</span>
                    <div class="flex items-center justify-center size-6">

                        <MenuButton
                            :class="[singleVideoMode ? 'rounded-lg w-8 h-8 p-2 flex justify-center items-center text-white bg-birdie-grey-medium hover:bg-birdie-blue mr-2' : 'bg-gray-700 text-white p-2 rounded-md hover:bg-gray-600']">
                            <span class="sr-only">Move to Folder</span>
                            <FolderIconOutline class="size-4" />
                        </MenuButton>



                    </div>

                    <transition enter-active-class="transition ease-out duration-100"
                        enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100"
                        leave-active-class="transition ease-in duration-75"
                        leave-from-class="transform opacity-100 scale-100"
                        leave-to-class="transform opacity-0 scale-95">
                        <MenuItems :key="'reload_' + reloadAll"
                            :class="[openSide == 'right' ? 'left-0 origin-bottom-left' : 'right-0 origin-bottom-right', 'absolute  bottom-full z-10 mb-2 w-60  rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none max-h-56 overflow-y-auto']">
                            <div class="py-1">
                                <MenuItem v-if="titleRoot != null" v-slot="{ active }" :key="'titleRoot_' + reloadAll">
                                <div v-if="_currentFolder == null"
                                    class="px-4 py-2 text-sm flex items-center justify-start gap-x-1 bg-birdie-blue text-white">
                                    <FolderIconSolid class="size-4 mr-2" />
                                    <span class="inline-block truncate font-bold">{{ titleRoot }}</span>
                                </div>
                                <a v-else href="#"
                                    @click.prevent.stop="moveToFolder({ id: rootFolder, name: titleRoot, root: rootFolder }); close()"
                                    :class="[active ? 'bg-gray-100 text-gray-900 outline-none' : 'text-gray-700', 'px-4 py-2 text-sm flex items-center justify-start']">
                                    <FolderIconSolid class="size-4 mr-2" />
                                    <span class="inline-block truncate font-bold">{{ titleRoot }}</span>
                                </a>
                                </MenuItem>
                                <MenuItem v-for="folder in foldersOrdered" v-slot="{ active }"
                                    :key="'folder_' + folder.id + '_' + reloadAll">

                                <div v-if="_currentFolder && folder.id == _currentFolder.id"
                                    class="pl-10 pr-4 py-2 text-sm flex items-center justify-start gap-x-1 bg-birdie-blue text-white">
                                    <span class="block size-4 ml-0 mr-2 flex-shrink-0 relative">
                                        <FolderIconOutline class="size-4 flex-shrink-0" />
                                        <div v-if="folder.is_secure"
                                            class="absolute bottom-0 -right-0.5 size-2 rounded-full bg-birdie-blue group-hover:bg-gray-100 flex items-center justify-center text-white">
                                            <LockClosedIcon class="size-5/6 " />
                                        </div>
                                    </span>
                                    <span class="inline-block truncate">{{ folder.name }}</span>
                                </div>
                                <a v-else href="#" @click.prevent.stop="moveToFolder(folder); close()" :class="[active ? 'bg-gray-100 text-gray-900 outline-none' : 'text-gray-700',
                                folder.is_secure && !folder.can_access ? 'pointer-events-none opacity-50' : '',
                                    'pl-10 pr-4 py-2 text-sm flex items-center justify-start group']">
                                    <span class="block size-4 ml-0 mr-2 flex-shrink-0 relative">
                                        <!-- <span v-html="folderIcon"></span> -->
                                        <FolderIconOutline class="size-4" />
                                        <div v-if="folder.is_secure"
                                            class="absolute bottom-0 -right-0.5 size-2 rounded-full bg-white group-hover:bg-gray-100 flex items-center justify-center text-gray-900">
                                            <LockClosedIcon class="size-5/6 " />
                                        </div>
                                    </span>
                                    <span class="inline-block truncate">{{ folder.name }}</span>
                                </a>
                                </MenuItem>
                            </div>
                            <div v-if="titleOtherRoot != null" class="py-1 border-t border-gray-200">
                                <MenuItem v-slot="{ active }" :key="'titleOtherRoot_' + reloadAll">
                                <a href="#"
                                    @click.prevent.stop="moveToFolder({ id: otherRootFolder, name: titleOtherRoot, root: otherRootFolder }); close()"
                                    :class="[active ? 'bg-gray-100 text-gray-900 outline-none' : 'text-gray-700', 'px-4 py-2 text-sm flex items-center justify-start']">
                                    <FolderIconSolid class="size-4 mr-2" />
                                    <span class="inline-block truncate font-bold">{{ titleOtherRoot }}</span>
                                </a>
                                </MenuItem>
                                <MenuItem v-for="folder in otherFoldersOrdered" v-slot="{ active }"
                                    :key="'other_folder_' + folder.id + '_' + reloadAll">
                                <a href="#" @click.prevent.stop="moveToFolder(folder); close()"
                                    :class="[active ? 'bg-gray-100 text-gray-900 outline-none' : 'text-gray-700',
                                    folder.is_secure && !folder.can_access ? 'pointer-events-none opacity-50' : '', 'pl-10 pr-4 py-2 text-sm flex items-center justify-start group']">
                                    <span class="block size-4 ml-0 mr-2 flex-shrink-0 relative">
                                        <!-- <span v-html="folderIcon"></span> -->
                                        <FolderIconOutline class="size-4" />
                                        <div v-if="folder.is_secure"
                                            class="absolute bottom-0 -right-0.5 size-2 rounded-full bg-white group-hover:bg-gray-100 flex items-center justify-center text-gray-900">
                                            <LockClosedIcon class="size-5/6 " />
                                        </div>
                                    </span>
                                    <span class="inline-block truncate">{{ folder.name }}</span>
                                </a>
                                </MenuItem>
                            </div>
                        </MenuItems>
                    </transition>
                </Menu>


                <button v-if="!singleVideoMode" @click="deleteSelectedVideos()"
                    class="bg-gray-700 text-white p-2 rounded-md hover:bg-gray-600 mr-2">
                    <TrashIcon class="size-4" />
                </button>
            </div>

            <div v-if="!singleVideoMode"
                :class="[deleteWarning ? 'w-full' : 'w-0', 'absolute bg-white flex items-center justify-beween gap-x-4 transition-all duration-300 h-full top-0 right-0 left-auto overflow-hidden rounded-md z-20']">
                <div
                    class="inline-block flex-grow font-bold text-center text-red-500 whitespace-nowrap overflow-hidden">
                    Deletion is irreversible. Do you confirm?
                </div>
                <button @click="deleteSelectedVideos" :disabled="deleteWaiting"
                    class=" text-red-500 px-4 py-1 hover:underline">Confirm</button>
                <button @click="cancelDelete()" :disabled="deleteWaiting"
                    class="text-gray-800 px-4 py-1 hover:underline">Cancel</button>
            </div>
        </div>




        <Teleport to="body">
            <div v-if="deleteWaiting || moveWaiting"
                class="fixed inset-0 bg-black/50 flex items-center justify-center pointer-events-auto backdrop-blur-sm z-50"
                style="z-index: 99999">
                <div
                    class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6 text-center flex justify-center items-center gap-x-4">
                    <Spinner class="size-4" />
                    <span v-if="singleVideoMode || selectedVideos.length == 1">{{ deleteWaiting ? 'Deleting video...' :
                        'Moving video...' }}</span>
                    <span v-else>{{ deleteWaiting ? 'Deleting videos...' :
                        'Moving videos...' }}</span>
                </div>
            </div>
        </Teleport>

    </div>
</template>

<script>

import { XMarkIcon, TrashIcon, CheckIcon, FolderIcon as FolderIconOutline } from "@heroicons/vue/24/outline"
import { FolderIcon as FolderIconSolid } from "@heroicons/vue/24/solid"
import { LockClosedIcon } from "@heroicons/vue/16/solid"
import Spinner from '@/Components/UI/Spinner'
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'


export default {
    name: 'Folders',
    props: {
        video: {
            type: Object,
            default: null
        },
        way: {
            type: String,
            default: 'incoming'
        },
        selectedVideos: {
            type: Array,
            default: []
        },
        currentFolder: {
            type: Object,
            default: null
        },
        folders: {
            type: Array,
            default: []
        },
        otherFolders: {
            type: Array,
            default: []
        },
        openSide: {
            type: String,
            default: 'left'
        }
    },
    components: {
        XMarkIcon, TrashIcon,
        Menu, MenuButton, MenuItem, MenuItems,
        LockClosedIcon, Spinner, CheckIcon, FolderIconSolid,
        FolderIconOutline
    },
    data() {
        return {
            deleteWarning: false,
            deleteWaiting: false,
            moveWaiting: false,
            otherFolderList: [],
            _currentFolder: null,
            _folders: this.folders,
            _otherFolders: this.otherFolders,
            _way: this.way,
            singleVideoMode: false,
            reloadAll: 0,
            //folderIcon: '<svg xmlns="http://www.w3.org/2000/svg" class="w-full h-full" viewBox="0 -960 960 960" stroke="none" fill="currentColor"><path d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h240l80 80h320q33 0 56.5 23.5T880-640v400q0 33-23.5 56.5T800-160H160Zm0-80h640v-400H447l-80-80H160v480Zm0 0v-480 480Z"/></svg>'
        }
    },
    created() {
        if (this.video != null && this.currentFolder == null) {
            this.singleVideoMode = true
            if (this.video.folder) {
                this._currentFolder = this.video.folder
            }
        } else if (this.video == null && this.currentFolder != null) {
            this.singleVideoMode = false
            this._currentFolder = this.currentFolder
        }
        console.log('_currentFolder', this._currentFolder)
    },
    methods: {
        openFolders() {
            // this.$emit('openFolders')
        },
        cancelDelete() {
            if (this.deleteWaiting) {
                return
            }
            this.deleteWarning = false
        },
        deleteSelectedVideos() {
            if (this.selectedVideos.length > 0) {
                if (!this.deleteWarning) {
                    this.deleteWarning = true
                    return
                }
                if (this.deleteWaiting) {
                    return
                }
                this.deleteWaiting = true
                let url = this.$page.props.api_url + '/v1/video/delete/bulk';
                const videoIds = this.selectedVideos.map(v => v.id)
                var params = {
                    video_ids: videoIds
                };
                axios.post(url, params)
                    .then(response => {
                        this.$emit('deletedSelectedVideos')
                        this.deleteWaiting = false
                        this.deleteWarning = false
                        let options = {
                            type: "default",
                            timeout: 2500,
                            position: "top-right",
                            hideProgressBar: false,
                        }
                        let message = 'Videos deleted'
                        this.$moshaToast(message, options)
                    })
                    .catch(e => {
                        this.deleteWaiting = false
                        const errorMessage = typeof e.response.data === 'string'
                            ? e.response.data
                            : e.response.data.message || 'An unknown error occurred';
                        let options = {
                            type: "danger",
                            timeout: 10000,
                            position: "top-right",
                            hideProgressBar: false,
                        }
                        this.$moshaToast("An error occurred:" + errorMessage, options)
                        console.warn(e);
                    });
            }
        },
        unselectAllVideos() {
            if (this.deleteWaiting) {
                return
            }
            this.deleteWarning = false
            this.$emit('unselectAllVideos')
        },
        moveToFolder(folder) {
            if (this.moveWaiting) {
                return
            }
            let canMove = true
            let messageCannotMove = 'Videos are already into this folder'
            let optionsCannotMove = {
                type: "warning",
                timeout: 5000,
                position: "top-right",
                hideProgressBar: false,
            }
            let moveToRoot = folder.id == this.otherRootFolder || folder.id == this.rootFolder
            let changedRoot = folder.id == this.otherRootFolder || folder.root == this.otherRootFolder

            if (folder.id == this.rootFolder && this._currentFolder == null) {
                canMove = false
            } else if (this._currentFolder && this._currentFolder.id == folder.id) {
                canMove = false
            } else if (folder.id == this.otherRootFolder || folder.root == this.otherRootFolder) {
                if (this.otherRootFolder == 'personal') {
                    // check if not moving into Personal, some videos belonging to another user
                    const currentUserId = this.$page.props.user.id
                    let videoUserIds = this.selectedVideos.map(v => v.user_id)
                    if (this.singleVideoMode && this.video != null) {
                        videoUserIds = [this.video.user_id]
                    }
                    // check if every video is owned by the current user
                    if (!videoUserIds.every(id => id == currentUserId)) {
                        canMove = false
                        messageCannotMove = 'You cannot move videos from other users into your Personal folder'
                    }
                }
            }
            if (!canMove) {
                this.$moshaToast(messageCannotMove, optionsCannotMove)
                return
            }
            this.moveWaiting = true
            let url = this.$page.props.api_url + '/v1/video/move/' + folder.id;
            let videoIds = this.selectedVideos.map(v => v.id)
            if (this.singleVideoMode && this.video != null) {
                videoIds = [this.video.id]
            }
            var params = {
                root: folder.root,
                video_ids: videoIds
            };
            axios.post(url, params)
                .then(response => {
                    this.$emit('movedSelectedVideos', folder)
                    this.moveWaiting = false
                    if (this.singleVideoMode && changedRoot) {
                        const oldFolders = JSON.parse(JSON.stringify(this._folders))
                        const oldOtherFolders = JSON.parse(JSON.stringify(this._otherFolders))
                        this._folders = oldOtherFolders
                        this._otherFolders = oldFolders
                        if (this._way == 'my') {
                            this._way = 'sent'
                        } else if (this._way == 'sent') {
                            this._way = 'my'
                        }
                    }
                    this._currentFolder = moveToRoot ? null : folder
                    this.reloadAll++
                    let options = {
                        type: "default",
                        timeout: 2500,
                        position: "top-right",
                        hideProgressBar: false,
                    }
                    let message = 'Videos moved to ' + folder.name
                    if (videoIds.length == 1) {
                        message = 'Video moved to ' + folder.name
                    }
                    this.$moshaToast(message, options)
                })
                .catch(e => {
                    this.moveWaiting = false
                    const errorMessage = typeof e.response.data === 'string'
                        ? e.response.data
                        : e.response.data.message || 'An unknown error occurred';
                    let options = {
                        type: "danger",
                        timeout: 10000,
                        position: "top-right",
                        hideProgressBar: false,
                    }
                    this.$moshaToast("An error occurred:" + errorMessage, options)
                    console.warn(e);
                });

        }

    },
    computed: {
        foldersOrdered() {
            return this._folders.sort((a, b) => a.name.localeCompare(b.name))
        },
        otherFoldersOrdered() {
            return this._otherFolders.sort((a, b) => a.name.localeCompare(b.name))
        },
        otherWay() {
            if (this._way == 'my') {
                return 'sent'
            } else if (this._way == 'sent') {
                return 'my'
            }
        },
        rootFolder() {
            if (this._way == 'my') {
                return 'personal'
            } else if (this._way == 'sent') {
                return 'team'
            } else if (this._way == 'received') {
                return 'incoming'
            }
        },
        otherRootFolder() {
            if (this._way == 'my') {
                return 'team'
            } else if (this._way == 'sent') {
                return 'personal'
            }
            return null
        },
        titleRoot() {
            if (this._way == 'my') {
                return 'Personal'
            } else if (this._way == 'sent') {
                return 'Team'
            } else if (this._way == 'search') {
                return 'Search results'
            } else if (this._way == 'received') {
                return 'Incoming'
            }
            return null
        },
        titleOtherRoot() {
            if (this._way == 'my') {
                return 'Team'
            } else if (this._way == 'sent') {
                return 'Personal'
            }
            return null
        }
    }
}
</script>

<style scoped></style>
